import { ClassifierValue } from "./classifier";

export interface License {
  id: number;
  number: string;
  status: LicenseStatus;
  license: ClassifierValue;
  advancedPracticeNursing?: boolean;
  advancedPracticeNursingGrantedAt?: string | null;
  dateOfIssue?: string;
}

export interface LicenseForm {
  firstName?: string;
  lastName?: string;
  text: string;
  userLicense: string;
  license: string;
}

export enum LicenseStatus {
  VALID = "VALID",
  CANCELED = "CANCELED",
  SUSPENDED = "SUSPENDED",
}
